import React from "react"
import FieldConfig from "../../../proto/field-config"
import {GROUP_NUMBER} from "../../../../gd/const/fields/field2-groups"
import FieldTimeSpent from "../../../generic/datetime/time-spent/time-spent";
import {FieldFilterType} from "../../../proto/types";

export default class FieldCompanyUserWorkdayDuration extends FieldTimeSpent {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                  = "Workday duration"
        this.typeGroup                  = GROUP_NUMBER
        this.typeDescription            = "Company user workday duration"
        this.filterType                 = FieldFilterType.NUMBER

        this.placeholderValueExample    = "Enter workday duration e.g. 7h 30m"
        this.hasStartEnd                = false

        this.presetHours = [
            {value: 60, label: "1"},
            {value: 120, label: "2"},
            {value: 180, label: "3"},
            {value: 240, label: "4"},
            {value: 300, label: "5"},
            {value: 360, label: "6"},
            {value: 420, label: "7"},
            {value: 480, label: "8"}
        ]

    }

    /*** DISPLAY VALUE FUNCTIONS [INPUT ONLY] ***/

    // getDisplayValue(value:any) {
    //     if (isNaN(value)) return value;
    //
    //     let res = value;
    //
    //     if (this.isValueValid(value)) {
    //         switch (typeof value) {
    //             case 'number':  res = value; break;
    //             default:        res = parseFloat(value); break;
    //         }
    //     }
    //
    //     return isNaN(res) ? null : gd.utils.minutesHumanize(res)
    // }

    /*** IMPORT EXPORT ***/

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        return this.getDisplayValue(rawValue)
    }
}
